import { Injectable, inject } from '@angular/core';
import { environment } from '@environments/environment';
import { paths } from '@platform/paths';
import { FullstoryService } from '@shared-lib/services/fullstory.service';
import { CookieConsentDialogComponent } from '@shared/components/cookie-consent-dialog/cookie-consent-dialog.component';
import { AnalyticsService } from '@shared/services/analytics.service';
import { CookieService } from 'ngx-cookie';
import { DialogService } from 'primeng/dynamicdialog';

const COOKIE_CONSENT_KEY = 'allowCookies';

@Injectable({
  providedIn: 'root',
})
export class CookieConsentService {
  private readonly dialogService = inject(DialogService);
  private readonly analyticsService = inject(AnalyticsService);
  private readonly fullstoryService = inject(FullstoryService);
  private readonly cookieService = inject(CookieService);

  showDialog(): void {
    if (environment.mobileApp?.isMobileApp) {
      return;
    }

    const cookiesAllowed = this.getCookieConsent();

    if (cookiesAllowed == null && location.pathname != `/${paths.COOKIE_POLICY}`) {
      this.dialogService
        .open(CookieConsentDialogComponent, {
          closable: false,
          closeOnEscape: false,
          transitionOptions: '0ms',
        })
        .onClose.subscribe((answer: boolean) => {
          this.setCookieConsent(answer);
          if (answer === true) {
            this.loadAnalytics();
          }
        });
    }
  }

  getCookieConsent(): boolean | null {
    const item = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (item === 'false') return false;
    if (item === 'true') return true;
    return null;
  }

  setCookieConsent(consent: boolean): void {
    localStorage.setItem(COOKIE_CONSENT_KEY, consent.toString());
  }

  loadAnalytics(): void {
    this.analyticsService.enableAnalyticsCollection();
    this.fullstoryService.init();
  }

  deleteAllCookies(): void {
    this.cookieService.removeAll();
    window.location.reload();
  }
}
